import { Link } from "react-router-dom";

import SocialLinks from "./social-links";

const exploreLinks = [
  { to: "/", label: "Home" },
  { to: "/articles", label: "Articles" },
  { to: "/about", label: "About" },
];

const legalLinks = [
  { to: "/privacy", label: "Privacy policy" },
  { to: "/terms", label: "Terms of service" },
];

function SiteFooter() {
  return (
    <footer className="border-t bg-secondary/40">
      <div className="container py-12">
        <div className="grid gap-10 md:grid-cols-[1.6fr_1fr_1fr]">
          <div>
            <Link to="/" className="font-serif text-xl font-semibold tracking-tight">
              Aiman<span className="text-primary">Re</span>.my
            </Link>
            <p className="mt-3 max-w-xs text-sm leading-6 text-muted-foreground">
              A personal notebook about things I&apos;m learning, small hobbies, and the
              quiet parts of everyday life. Jitra, Kedah is my hometown.
            </p>
            <SocialLinks className="mt-5" />
          </div>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-[0.18em] text-foreground">
              Explore
            </h2>
            <ul className="mt-4 space-y-2 text-sm">
              {exploreLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-muted-foreground transition-colors hover:text-foreground"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-[0.18em] text-foreground">
              The small print
            </h2>
            <ul className="mt-4 space-y-2 text-sm">
              {legalLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-muted-foreground transition-colors hover:text-foreground"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} AimanRe.my. Jitra, Kedah is my hometown.</p>
          <p>
            Ads keep this site free.{" "}
            <Link to="/privacy" className="underline underline-offset-4 hover:text-foreground">
              How ads work here
            </Link>
            .
          </p>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
